export default "__VITE_ASSET__Jx$Z_Yuy__"